import React from "react"
import { MyContainer } from "../container"
import PropTypes from 'prop-types';

export const withContainer = Component => {
    const WithContainer = ({fullWidth, insidePaper, ...props}) => {
        const comp = <Component {...props} insidePaper={insidePaper} />

        return (fullWidth || insidePaper) ? comp : <MyContainer>{comp}</MyContainer>;
    }

    WithContainer.propTypes = {
        fullWidth: PropTypes.bool,
    }

    WithContainer.defaultProps = {
        fullWidth: false,
    }

    return WithContainer;
}